import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { CreateApplicationBlock } from "../../components/ApplicationBlocks/CreateApplicationBlock";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../components/Layout/Layout";
import { useAppDispatch } from "../../store";
import { useEffect } from "react";
import { fetchCustomers } from "../../store/slices/customers";
import { fetchCreateApplication } from "../../store/slices/applications";
import { ApplicationForm } from "../../model/applications";
import { useFormik } from "formik";
import { fetchAllProjects } from "../../store/slices/projects";
import { normalizeApplicationForm } from "../../helpers/normalizeApplicationForm";
import { SortingTypes } from "../../helpers/SortingTypes";

const getDefaultPaginatedListFilters = (prefix: string) =>
  ({
    limit: "100000",
    offset: "0",
    sort_column: `${prefix}.created_at`,
    sort_direction: SortingTypes.DESC,
  }) as const;

export const CreateApplicationPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formik = useFormik<ApplicationForm>({
    initialValues: {
      name: "",
      customer_id: null,
      project_id: null,
      legal_entity_id: null,
      profile_id: null,
      candidate_grade: [],
      candidate_requirements: "",
      job_duties: "",
      project_description: "",
      bitrix_contract_link: "",
      sales_max_offer_general: "",
      sales_max_offer_regions: "",
      sales_max_offer_moscow: "",
      marginality: null,
      purchase_rate_max: "",
      required_number: null,
      location: "",
      job_format: "",
      office_address: "",
      job_workload: "",
      attraction_period: "",
      comments: "",
      attachments: [],
      attachments_delete: [],
    },
    validate: (values) => {
      const errors: any = {};

      const isNonEmptyString = (v: any) => typeof v === "string" && v.trim().length > 0;
      const isPresentId = (v: any) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "");

      if (!isNonEmptyString(values.name)) errors.name = true;
      if (!isPresentId(values.customer_id)) errors.customer_id = true;
      if (!isPresentId(values.project_id)) errors.project_id = true;
      if (!isPresentId(values.profile_id)) errors.profile_id = true;
      if (!isPresentId(values.legal_entity_id)) errors.legal_entity_id = true;

      if (!Array.isArray(values.candidate_grade) || values.candidate_grade.length === 0) errors.candidate_grade = true;
      if (!isNonEmptyString(values.candidate_requirements)) errors.candidate_requirements = true;
      if (!isNonEmptyString(values.job_duties)) errors.job_duties = true;
      if (!isNonEmptyString(values.project_description)) errors.project_description = true;

      if (String(values.marginality ?? "").trim() === "") errors.marginality = true;
      if (String(values.required_number ?? "").trim() === "") errors.required_number = true;

      if (!isPresentId(values.job_format)) errors.job_format = true;
      if (!isPresentId(values.job_workload)) errors.job_workload = true;
      if (!isPresentId(values.attraction_period)) errors.attraction_period = true;

      return errors;
    },
    validateOnMount: true,
    onSubmit: () => {},
  });

  useEffect(() => {
    dispatch(fetchCustomers({ params: { filters: getDefaultPaginatedListFilters("customer") } }));
    dispatch(fetchAllProjects({ params: { filters: getDefaultPaginatedListFilters("project") } }));
  }, [dispatch]);

  return (
    <Layout>
      <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
        <Text color="gray.500" cursor="pointer" onClick={() => navigate("/applications")} display="flex" alignItems="center" gap="8px">
          <ArrowBackIcon />К списку заявок
        </Text>
        <Flex flexDirection="column" gap="4px">
          <Text fontSize={24} fontWeight={500}>
            Создание заявки
          </Text>
          <Text color="gray.500">Заполните информацию о новой заявке на подбор</Text>
        </Flex>
        <CreateApplicationBlock formik={formik} />
        <Flex gap="16px" justifyContent="flex-end">
          <Button onClick={() => navigate("/applications")}>Отмена</Button>
          <Button
            bg="#2563eb"
            color="white"
            _hover={{ bg: "#2563eb" }}
            _active={{ bg: "#2563eb" }}
            isDisabled={!formik.isValid}
            onClick={() => {
              dispatch(fetchCreateApplication(normalizeApplicationForm(formik.values))).then((res: any) => {
                if (res.payload.id) {
                  navigate(`/applications/${res.payload.id}`);
                }
              });
            }}
          >
            Создать заявку
          </Button>
        </Flex>
      </Flex>
    </Layout>
  );
};
